module.exports = __webpack_public_path__ + "media/images/icons/v2/coins-hand-5425690fc942f0468f7c362b86b89cc2.svg";